import Icon from '@ant-design/icons'
import * as React from 'react'

import { NovaIconProps } from '../types/iconTypes'

const Right = (props: NovaIconProps) => (
  <Icon
    {...props}
    component={() => (
      <svg
        width="1em"
        height="1em"
        focusable={false}
        viewBox="2 2 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.2925 16.2917C22.2925 16.8037 22.0975 17.3157 21.7075 17.7057L11.4145 27.9987C11.0235 28.3897 10.3905 28.3897 10.0005 27.9987C9.61051 27.6077 9.61051 26.9757 10.0005 26.5847L20.2935 16.2917L10.0005 5.99874C9.61051 5.60774 9.61051 4.97568 10.0005 4.58468C10.3915 4.19368 11.0245 4.19368 11.4145 4.58468L21.7075 14.8776C22.0985 15.2676 22.2925 15.7797 22.2925 16.2917Z"
          fill="currentColor"
        />
      </svg>
    )}
  />
)

export default Right
